import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "jalali-moment";
import { ReactSession } from "react-client-session";
import "./AgahiPage.css";
import { IoMdArrowForward, IoMdClose } from "react-icons/io";
import { IoCalendarOutline, IoBedOutline, IoCarOutline } from "react-icons/io5";
import { BiShapeSquare, BiCheck } from "react-icons/bi";
import { MdApartment } from "react-icons/md";
import MelkCard from "../../Components/MelkCard/MelkCard";
import Carousel, { consts } from "react-elastic-carousel";
import { BsChevronLeft, BsChevronRight, BsBookmark } from "react-icons/bs";
import { useState } from "react";
import { MdChevronRight, MdKeyboardArrowLeft } from "react-icons/md";
import { AiOutlineRight, AiOutlineLeft, AiOutlineExclamationCircle, AiOutlineShareAlt } from "react-icons/ai";
import { useMediaQuery } from "react-responsive";
// const pictures = [
//     { src: "https://kharidmag.com/wp-content/uploads/2020/11/duplex-house7.jpg", alt: "" },
//     { src: "https://www.jowhareh.com/images/Jowhareh/galleries/poster_d0eb4d6d-5aa4-4696-87f7-dc756257c110.jpeg", alt: "" },
//     { src: "https://andishe-estate.com/wp-content/uploads/2019/10/%D8%AE%D8%A7%D9%86%D9%87-%D9%88%DB%8C%D9%84%D8%A7%DB%8C%DB%8C-220-%D9%85%D8%AA%D8%B1%DB%8C-%D8%AF%D8%B1-%D9%81%D8%A7%D8%B2-%D8%AF%D9%88-%D8%A7%D9%86%D8%AF%DB%8C%D8%B4%D9%87-21.jpg", alt: "" },
//     { src: "https://static2.ilna.news/thumbnail/V1Vj5pTx9Y3V/zD2ly951Lbe1X4vBXmeYxnwvBKd2o-upCBoRpuXWWQ3xVYIwBtE8SJc5CgG8w1SR1HhaeHPcWe7Z4QQxwQ5aCQuC6bW65Yo2vzNA1A_oYcME-xuDHnCGIC-kHgCp4We0QxZgWUBqDYSCKlL5SndO1w96qHB4I0VpXuOejRjZDSys4NdjIqNZJEQ6csj1vAj0lFuBpM2etuk,/Untitled.jpg", alt: "" },
//     { src: "https://naab-house.com/wp-content/uploads/2021/01/Ankara-Melk.jpg", alt: "" },
// ];
function AgahiPage(props) {
    const res700 = useMediaQuery({ query: "(max-width : 750px)" });
    const res600 = useMediaQuery({ query: "(max-width : 650px)" });
    const res500 = useMediaQuery({ query: "(max-width : 507px)" });
    const res360 = useMediaQuery({ query: "(max-width : 360px)" });
    const [pictures, setPictures] = useState([{ src: "../../Images/02.jpg", alt: "" }]);
    const [imageSlider, setImageSlider] = useState(0);
    const handleRightMove = () => {
        if (imageSlider === 0) setImageSlider(pictures.length - 1);
        else setImageSlider(imageSlider - 1);
    };
    const handleLeftMove = () => {
        if (imageSlider + 1 === pictures.length) setImageSlider(0);
        else setImageSlider(imageSlider + 1);
    };
    const myArrow = ({ type, onClick, isEdge }) => {
        const Pointer = type !== consts.PREV ? MdKeyboardArrowLeft : MdChevronRight;
        return (
            <div className="arrowsStyleAgahiCards" onClick={onClick} disabled={isEdge}>
                <Pointer />
            </div>
        );
    };

    useEffect(() => {
        props.header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    function separate(Number) {
        Number += "";
        Number = Number.replace(",", "");
        var x = Number.split(".");
        var y = x[0];
        var z = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
        return y + z;
    }

    const location = useLocation();
    const [agahiData, setAgahiData] = useState([]);
    const [advertiserData, setAdvertiserData] = useState([]);
    useEffect(() => {
        var postId = location.pathname.split("/");
        console.log(postId[2]);
        axios
            .get("https://hammaskan.ir:8443/api/advertises/" + postId[2])
            .then((res) => {
                console.log(res.data.data[0]);
                setAgahiData(res.data.data[0]);
                //
                var images = [];
                res.data.data[0].image.forEach((item, index) => {
                    images.push({ src: "https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.link, alt: "" });
                    if (index === res.data.data[0].image.length - 1) {
                        setPictures(images);
                        console.log(images);
                    }
                });
                //
                axios
                    .get("https://hammaskan.ir:8443/api/users/" + res.data.data[0].advertiserId)
                    .then((res) => {
                        console.log(res.data.data);
                        setAdvertiserData(res.data.data);
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    const [agahiList, setAgahiList] = useState([]);
    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/advertises", {
                params: {
                    perPage: 20,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                setAgahiList(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);
    return (
        <div>
            {agahiData ? (
                <div className="agahiPage">
                    <div className="agahiContainerPage">
                        <div className="informationAgahiContainer">
                            <div className="row1InfoAgahi">
                                <Link to={{ pathname: "/amlak" }}>
                                    <div className="bazgashtAgahi">
                                        <IoMdArrowForward style={{ fontSize: "15px", marginTop: "1px", marginLeft: "2px" }} />
                                        <span>بازگشت به صفحه قبل</span>
                                    </div>
                                </Link>
                                <div className="codeboxAgahi">
                                    <span>کد ملک : {agahiData.id}</span>
                                </div>
                            </div>
                            {res600 ? (
                                <div className="pictureSliderAGahi">
                                    <div className="sliderBtnsAgahi">
                                        <div>
                                            <div className="numberCounterAgahiSliderBtn">
                                                {imageSlider + 1}/{pictures.length}
                                            </div>
                                        </div>
                                        <div className="arrowDivsAgahi">
                                            <div>
                                                <BsChevronRight onClick={() => handleRightMove()} className="arrowStyleAgahi" />
                                            </div>
                                            <div>
                                                <BsChevronLeft onClick={() => handleLeftMove()} className="arrowStyleAgahi" />
                                            </div>
                                        </div>
                                        <div></div>
                                    </div>
                                    <img alt={pictures[imageSlider].alt} src={pictures[imageSlider].src} />
                                </div>
                            ) : (
                                ""
                            )}
                            {res600 ? (
                                <div className="picturesSliderPicAgahi" style={{ justifyContent: "flex-start" }}>
                                    {pictures.map((item, index) => {
                                        return (
                                            <div
                                                style={{ marginLeft: "6px" }}
                                                onClick={() => {
                                                    setImageSlider(index);
                                                }}
                                                className="picItemDivAgahiSlider"
                                            >
                                                <img alt={item.alt} src={item.src} />
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                ""
                            )}
                            <div style={{ marginRight: "8px" }}>
                                <div className="titleAgahiPage">
                                    <h2>{agahiData.title}</h2>
                                </div>
                                <div className="timeAgahiPage">
                                    <span>
                                        {moment(agahiData.updatedAt, "YYYYMMDD").locale("fa").fromNow()} در {agahiData.city}
                                    </span>
                                </div>
                                <div className="priceAgahiPage">
                                    <h2>قیمت:{separate(agahiData.deposit)} تومان</h2>
                                </div>
                                <div className="timeAgahiPage">
                                    <span style={{ color: "#666666" }}>قیمت هر متر: {separate(agahiData.deposit / agahiData.area)} تومان</span>
                                </div>

                                <div className="resAgahiPagecul">
                                    <div className="featuresAgahiPage">
                                        <div>
                                            <MdApartment />
                                            <span>{agahiData.buildingType}</span>
                                        </div>
                                        <div>
                                            <IoCalendarOutline />
                                            <span>{agahiData.yearOfConstruction} سال ساخت</span>
                                        </div>
                                        <div>
                                            <IoBedOutline />
                                            <span>{agahiData.room} خوابه</span>
                                        </div>
                                        <div>
                                            <BiShapeSquare />
                                            <span>{agahiData.area} متر</span>
                                        </div>
                                        <div>
                                            <IoCarOutline />
                                            <span>پارکینگ : {agahiData.parking ? "دارد" : "ندارد"}</span>
                                        </div>
                                    </div>
                                    <div className="personInfDivAgahi">
                                        <div className="infPersonContainerAgahi" style={{ paddingLeft: "32px" }}>
                                            <div className="personAvatarAgahi"></div>
                                            <div className="personInfAgahi">
                                                {advertiserData ? (
                                                    <div>
                                                        <h3>
                                                            {advertiserData.firstName} {advertiserData.lastName}
                                                        </h3>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <h3>متین نوروزپور</h3>
                                                    </div>
                                                )}
                                                {agahiData.advertiserType == "normalUser" ? (
                                                    <div>
                                                        <span>کاربر سایت</span>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <span>املاکی</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="numberPersonContainerAgahi">
                                            <div className="numberBoxAgahi">
                                                <h3>{agahiData.advertiserPhone}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="emkanatHeader">
                                    <h4>امکانات و ویژگی ها</h4>
                                </div>
                                <div className="emkanatAmlak">
                                    {agahiData.warehouse ? (
                                        <div>
                                            <span>انباری : </span>
                                            <span style={{ color: "#fd4900" }}> دارد </span>
                                        </div>
                                    ) : (
                                        <div>
                                            <span>انباری : </span>
                                            <span> ندارد </span>
                                        </div>
                                    )}
                                    {agahiData.elevator ? (
                                        <div>
                                            <span>آسانسور : </span>
                                            <span style={{ color: "#fd4900" }}> دارد </span>
                                        </div>
                                    ) : (
                                        <div>
                                            <span>آسانسور : </span>
                                            <span> ندارد </span>
                                        </div>
                                    )}
                                    {agahiData.parking ? (
                                        <div>
                                            <span>پارکینگ : </span>
                                            <span style={{ color: "#fd4900" }}> دارد </span>
                                        </div>
                                    ) : (
                                        <div>
                                            <span>پارکینگ : </span>
                                            <span> ندارد </span>
                                        </div>
                                    )}
                                    {/* <div>
                                        <span>نگهبان</span>
                                    </div>
                                    <div>
                                        <span>بالکن</span>
                                    </div>
                                    <div>
                                        <span>استخر</span>
                                    </div> */}
                                </div>
                                <div className="explanationBoxAmlak">
                                    <div className="headerExpBoxAmlak">
                                        <h4>توضیحات ملک</h4>
                                    </div>
                                    <div className="textExpBoxAmlak">
                                        <p>{agahiData.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="leftSizeAgahiContainer">
                            {!res600 ? (
                                <div className="pictureSliderAGahi">
                                    <div className="sliderBtnsAgahi">
                                        <div>
                                            <div className="numberCounterAgahiSliderBtn" style={{ textAlign: "center" }}>
                                                {imageSlider + 1}/{pictures.length}
                                            </div>
                                        </div>
                                        <div className="arrowDivsAgahi">
                                            <div>
                                                <BsChevronRight onClick={() => handleRightMove()} className="arrowStyleAgahi" />
                                            </div>
                                            <div>
                                                <BsChevronLeft onClick={() => handleLeftMove()} className="arrowStyleAgahi" />
                                            </div>
                                        </div>
                                        <div></div>
                                    </div>
                                    <img alt={pictures[imageSlider].alt} src={pictures[imageSlider].src} />
                                </div>
                            ) : (
                                ""
                            )}
                            {!res600 ? (
                                <div className="picturesSliderPicAgahi" style={{ justifyContent: "flex-start" }}>
                                    {pictures.map((item, index) => {
                                        return (
                                            <div
                                                style={{ marginLeft: "6px" }}
                                                onClick={() => {
                                                    setImageSlider(index);
                                                }}
                                                className="picItemDivAgahiSlider"
                                            >
                                                <img alt={item.alt} src={item.src} />
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                ""
                            )}
                            {/* <div className="btnsShareRepAgahi">
                                <div className="reportAgahiBtn">
                                    <AiOutlineExclamationCircle />
                                    <span> گزارش آگهی </span>
                                </div>
                                <div className="reportAgahiBtn">
                                    <AiOutlineShareAlt />
                                    <span> اشتراک گذاری </span>
                                </div>
                                <div className="reportAgahiBtn">
                                    <BsBookmark />
                                    <span> نشان شدن </span>
                                </div>
                            </div>
                            <div className="positionInMapAgahi">
                                <div className="headerExpBoxAmlak">
                                    <h4>موقعیت در نقشه</h4>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="simularAgahisAgahi">
                        <div className="headerExpBoxAmlak">
                            <h4>آگهی های مشابه</h4>
                        </div>
                        {agahiList.length !== 0 ? (
                            <div className="agahiAsliderContinaerAghai">
                                <Carousel className="sliderCompo" pagination={false} showArrows={true} isRTL={true} renderArrow={myArrow} itemsToShow={res360 ? 1 : res500 ? 2 : res600 ? 3 : res700 ? 4 : 5}>
                                    {agahiList.map(function (item, i) {
                                        if (item.image.length !== 0) {
                                            return (
                                                <MelkCard
                                                    backgroundColor="white"
                                                    margin="16px 4px "
                                                    boxshodow
                                                    title={item.title}
                                                    width={"163px"}
                                                    position={item.city}
                                                    type={item.advertiseType}
                                                    amlak={item.advertiseUseType}
                                                    meter={item.area}
                                                    price={separate(item.deposit) + " تومان "}
                                                    time={moment(item.updatedAt).locale("fa").format("YYYY/MM/DD")}
                                                    image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image[0].link}
                                                />
                                            );
                                        } else {
                                            return <span></span>;
                                        }
                                    })}
                                </Carousel>
                            </div>
                        ) : (
                            <div className="agahiAsliderContinaerAghai"></div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="agahiPage"></div>
            )}
        </div>
    );
}

export default AgahiPage;
